export function generateNumericId() {
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
}

export function generateId() {
  return String(generateNumericId());
}
